import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { GridApi } from 'ag-grid-community';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { SamlSsoConfigurationComponent } from '../saml-sso-configuration.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-authentication-summary',
  templateUrl: './authentication-summary.component.html',
  styleUrl: './authentication-summary.component.scss'
})
export class AuthenticationSummaryComponent implements OnInit {
  collapesedOrNot: boolean;
  columnDefs: any;
  operations: any;
  loperations: any;
  gridApi: GridApi;
  selectedRow: any;
  rowData: any;
  userType: string;
  advanceSearch: any;
  statusList: any = [];
  authTypeList: any = [];
  authForm: UntypedFormGroup;
  isSettings: boolean = true;

  constructor(
    private summaryService: AdministrationSummaryService,
    private commonService: CommonService,
    private modalService: NgbModal,
  ){

  }

  ngOnInit(): void {

    this.collapesedOrNot = false;

    this.statusList = [
      { "value": "-1", "label": "All" },
      { "value": "1", "label": "Active" },
      { "value": "0", "label": "Inactive" }
    ];

    this.columnDefs = [
      {
        "headerName": "Authentication Name",
        "field": "AUTH_NAME"
      },
      {
        "headerName": "Authentication Type",
        "field": "AUTH_TYPE_CODE"
      },
      {
        "headerName": "Status",
        "field": "STATUS"
      }
    ];

    this.authForm = new UntypedFormGroup({
      AuthName: new UntypedFormControl(""),
      AuthType: new UntypedFormControl("-1"),
      Status: new UntypedFormControl("-1")
    });

    this.GetAuthTypes();

    this.setSearch();
  }


  setOperations(rowData: any[]) {
    this.operations = [];
    this.operations.push({
      "name": "Add Authentication",
      "id": "add"
    });
    this.operations = this.operations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });

    rowData.forEach(element =>{
      element.STATUS = element.STATUS ? 'Active':'Inactive';
      this.loperations=[];
      this.isSettings = true;
      this.loperations.push({
        "name": "Add Organization",
        "id": "add"
      });
      this.loperations.push({
        "name": "View",
        "id": "view"
      });
      this.loperations.push({
        "name": "Edit",
        "id": "edit"
      });
      this.loperations.push({
        "name": "Delete",
        "id": "delete"
      });

      if(!element.IS_DEFAULT){
        element["Operations"] = this.loperations.map(operation => {
          return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
        });
      }
    })

    this.rowData=rowData;
  };

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  };

  onCallbackOperation(opr) {
    opr.callback();
  };

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked() {
    let modalRef = this['self'].modalService.open(SamlSsoConfigurationComponent, {
      backdrop: false,
      keyboard: false,
      windowClass:'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content= {
      heading: 'Edit',
      content: {authTypeList : this['self'].authTypeList, RecordData:this['self'].selectedRow}
    }
    modalRef.result.then(result=>{
      var formData = this['self'].authForm.value;
      this['self'].setSearch(formData);
    })
  };

  add() {
    let modalRef = this['self'].modalService.open(SamlSsoConfigurationComponent, {
      backdrop: false,
      keyboard: false,
      windowClass:'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content= {
      heading: 'Add',
      content: {authTypeList : this['self'].authTypeList}
    }
    modalRef.result.then(result=>{
      var formData = this['self'].authForm.value;
      this['self'].setSearch(formData);
    })
  };

   view(RecordData: any) {
    let modalRef = this['self'].modalService.open(SamlSsoConfigurationComponent, {
      backdrop: false,
      keyboard: false,
      windowClass:'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content= {
      heading: 'View',
      content: {authTypeList : this['self'].authTypeList, RecordData:RecordData}
    }
    modalRef.result.then(result=>{
      var formData = this['self'].authForm.value;
      this['self'].setSearch(formData);
    })
  };

  edit(RecordData: any) {
    let modalRef = this['self'].modalService.open(SamlSsoConfigurationComponent, {
      backdrop: false,
      keyboard: false,
      windowClass:'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content= {
      heading: 'Edit',
      content: {authTypeList : this['self'].authTypeList, RecordData:RecordData}
    }
    modalRef.result.then(result=>{
      var formData = this['self'].authForm.value;
      this['self'].setSearch(formData);
    })
  };

  delete(RecordData: any) {
    let id = RecordData['ID'];
    const modalRef = this['self'].modalService.open(DeleteBoxComponent, {backdrop: false})
    modalRef.componentInstance.Content= { heading: 'Delete', custommessage: 'The Authentication ' + "'" + RecordData['AUTH_NAME'] + "'" + ' will be deleted. Do you want to proceed?', ProceedButtonName: "Yes", TerminateButtonName: "No" }
    modalRef.result.then(result => {
      if (result == "okclick") {
        this['self'].summaryService.Delete('api/configuration/delete?id=' + id).subscribe(summary => {
          if (summary["Status"] == 0){
            this['self'].commonService.SuccessBanner(summary["Message"]);
            this['self'].setSearch();
          }
          else{
            this['self'].commonService.ValidationBanner(summary["Message"]);
          }
        });
      }
    });
  }

  setSearch() {
    this.selectedRow = null;
    this.summaryService.PostData('api/Configuration/GetAuthSearchSummary', this.authForm.value).subscribe(summary => {
      this.setOperations(summary);
      this.selectedRow = null;
    });
  };

  ViewAll() {
    this.SearchClear();
    this.setSearch();
  }


  SearchClear() {
    this.authForm = new UntypedFormGroup({
      AuthName: new UntypedFormControl(""),
      AuthType: new UntypedFormControl("-1"),
      Status: new UntypedFormControl("-1")
    });
    this.selectedRow = null;
  };

  AdvanceSearch() {
    this.setSearch();
  };

  GetAuthTypes(){
    this.summaryService.getConfiguration('api/configuration/getauthtypes').subscribe((res)=>{

      this.authTypeList = [{"value":"-1","label":"All"}];
      res.forEach(x=>{
        this.authTypeList.push({"value":x.AUTH_TYPE_CODE,"label":x.NAME})
      });
    })
  }
}
